import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { CollectionExhibitInfoPageModelState, ConnectState } from '@/models/connect';
import { ChangeAction } from '@/models/exhibitInfoPage';
import FViewportCards_Exhibit from '@/components/FAntvG6/FViewportCards_Exhibit';

interface ViewportsProps {
  dispatch: Dispatch;

  collectionExhibitInfoPage: CollectionExhibitInfoPageModelState;
}

function Viewports({ dispatch, collectionExhibitInfoPage }: ViewportsProps) {

  // async function onChange(payload: Partial<ExhibitInfoPageModelState>) {
  //   await dispatch<ChangeAction>({
  //     type: 'exhibitInfoPage/change',
  //     payload,
  //   });
  // }

  if (!collectionExhibitInfoPage.graphShow) {
    return null;
  }

  return (<FViewportCards_Exhibit
    exhibitID={collectionExhibitInfoPage.exhibit_ID}
    version={collectionExhibitInfoPage.side_Version}
    graphShow={[
      'relationship',
      'authorization',
      'dependency',
    ]}
    onMount={({ hasData }) => {
      dispatch<ChangeAction>({
        type: 'exhibitInfoPage/change',
        payload: {
          graphShow: hasData,
        },
      });
    }}
  />);
}

export default connect(({ collectionExhibitInfoPage }: ConnectState) => ({
  collectionExhibitInfoPage,
}))(Viewports);
